export class AddressModel {
  Name: string;
  StreetAddress: string;
  Number: string;
  PostalCode: string;
  City: string;
  Country: string;
}